import { useState } from "react";
import api from "../../services/api";
import VariantButton from "../../components/variant-button/variant-button";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/auth/login", {
        email,
        password,
      });
      if (response.data.success) {
        localStorage.setItem("user", JSON.stringify(response.data.data));
        window.location.href = "/dashboard";
      }
    } catch (err) {
      setError("Sai tài khoản hoặc mật khẩu !");
    }
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center h-screen">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">
          Đăng nhập <br /> Nail View Blogs
        </h2>
        {error && (
          <div className="relative">
            <p className="bg-red-500 text-white p-2 mb-4 rounded-md shadow">
              {error}
            </p>
            <button
              onClick={() => setError("")}
              className="absolute right-3 top-1 text-white text-xl hover:text-gray-200 active:translate-y-1"
            >
              &times;
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 p-2 w-full border rounded-md"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700">
              Mật khẩu
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 p-2 w-full border rounded-md"
              required
            />
          </div>
          <VariantButton
            props={{
              onClick: null,
              title: "Đăng nhập",
            }}
          />
        </form>
      </div>
    </div>
  );
}
